<template>
  <li @click="hideSidebar">
    <component :is="tag" v-bind="mergedProps" class="nav-link">
      <slot>
        <i v-if="link.icon" :class="link.icon"></i>
        <p>{{ link.name }}</p>
      </slot>
    </component>
  </li>
</template>

<script>
export default {
  inheritAttrs: false,

  inject: {
    autoClose: {
      default: true,
    },
  },

  props: {
    link: {
      type: [String, Object],
      default: () => {
        return {
          name: "",
          path: "",
          icon: "",
        };
      },
    },
    tag: {
      type: String,
      default: "router-link",
    },
  },

  computed: {
    linkProps() {
      if (typeof this.link === "string") {
        return { to: this.link };
      } else if (typeof this.link === "object") {
        return {
          to: this.link.path || { name: this.link.name },
        };
      }
      return {};
    },
    mergedProps() {
      return {
        ...this.linkProps,
        ...this.$attrs,
      };
    },
  },

  methods: {
    hideSidebar() {
      if (this.autoClose && this.$sidebar?.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
